export const itMessages = {
  "footer.left.text": "Domande? {faqLink} oppure contattaci.",
  "links.faqsLink": "",
  "footer.left.readFaqs": "",
  "footer.right.text":
    "{capitalAtRiskLink}: ogni investimento è soggetto al rischio di mercato.",
  "links.riskWarningLink": "",
  "footer.right.riskWarning": "",
  "footer.right.copyRight":
    "MFM Investment Ltd. Authorised and regulated by the FCA.",
  "contacts.phone": "",
  "contacts.email": "",
  "page.serviceUnavailable.title":
    "Oh no! Il servizio non è al momento disponibile",
  "page.serviceUnavailable.markdown": `Ci scusiamo ma il servizio è al momento in manutenzione e sarà nuovamente disponibile tra alcuni minuti.
  Mentre aspetti ti consigliamo di dare uno sguardo al nostro [blog](https://blog.moneyfarm.com/it/) o al nostro [canale youtube](https://www.youtube.com/c/moneyfarm)`,
};
